export const CompleteProfileSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={224} height={223} fill="none">
    <path
      fill="#0038FF"
      d="M208.932 146.557c-9.207 18.548-25.548 37.81-45.412 41.51-30.029 5.596-36.828 30.565-88.059 21.335-7.98-1.427-15.226-3.656-21.803-6.532a84.027 84.027 0 0 1-9.965-5.216c-28.313-17.367-40.106-48.89-37.32-79.833 3.68-40.73 31.992-56.603 50.25-65.677 18.236-9.073 44.253-50.182 94.68-41.555 7.669 1.316 15.227 3.5 22.405 6.71 16.386 7.335 32.214 20.823 40.106 38.524a79.564 79.564 0 0 1 1.672 4.057c10.144 26.864 5.997 61.352-6.554 86.677Z"
    />
    <path
      fill="#fff"
      d="M208.932 146.557c-9.207 18.548-25.548 37.81-45.412 41.51-30.029 5.596-36.828 30.565-88.059 21.335-7.98-1.427-15.226-3.656-21.803-6.532a84.027 84.027 0 0 1-9.965-5.216c-28.313-17.367-40.106-48.89-37.32-79.833 3.68-40.73 31.992-56.603 50.25-65.677 18.236-9.073 44.253-50.182 94.68-41.555 7.669 1.316 15.227 3.5 22.405 6.71 16.386 7.335 32.214 20.823 40.106 38.524a79.564 79.564 0 0 1 1.672 4.057c10.144 26.864 5.997 61.352-6.554 86.677Z"
      opacity={0.7}
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M210.894 203.539h5.974M6.574 203.539h199.95"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M215.129 76.088v26.306h-36.717V76.088h2.542v2.028c0 .513.423.936.958.936.245 0 .491-.089.669-.267a1.05 1.05 0 0 0 .267-.669v-2.028h5.552v2.028c0 .513.423.936.936.936a.947.947 0 0 0 .959-.936v-2.028h5.528v2.028c0 .513.424.936.959.936a.942.942 0 0 0 .936-.936v-2.028h5.551v2.028c0 .513.424.936.937.936a.946.946 0 0 0 .958-.936v-2.028h5.529v2.028c0 .513.424.936.959.936a.942.942 0 0 0 .936-.936v-2.028h2.541Zm-30.653 19.64H181.6v2.854h2.876v-2.854Zm0-4.147H181.6v2.876h2.876v-2.876Zm0-4.146H181.6v2.853h2.876v-2.853Zm0-4.147H181.6v2.854h2.876v-2.854Zm4.57 12.44h-2.853v2.854h2.853v-2.854Zm0-4.147h-2.853v2.876h2.853v-2.876Zm0-4.146h-2.853v2.853h2.853v-2.853Zm0-4.147h-2.853v2.854h2.853v-2.854Zm4.57 12.44h-2.853v2.854h2.853v-2.854Zm0-4.147h-2.853v2.876h2.853v-2.876Zm0-4.146h-2.853v2.853h2.853v-2.853Zm0-4.147h-2.853v2.854h2.853v-2.854Zm4.593 12.44h-2.876v2.854h2.876v-2.854Zm0-4.147h-2.876v2.876h2.876v-2.876Zm0-4.146h-2.876v2.853h2.876v-2.853Zm0-4.147h-2.876v2.854h2.876v-2.854Zm4.57 12.44h-2.876v2.854h2.876v-2.854Zm0-4.147h-2.876v2.854h2.876v-2.854Zm0-4.124h-2.876v2.854h2.876v-2.854Zm0-4.146h-2.876v2.853h2.876v-2.853Zm4.57 12.44h-2.854v2.853h2.854V95.75Zm0-4.147h-2.854v2.853h2.854v-2.853Zm0-4.125h-2.854v2.854h2.854v-2.854Zm0-4.146h-2.854v2.853h2.854v-2.853Zm4.57 12.44h-2.853v2.853h2.853v-2.853Zm0-4.147h-2.853v2.854h2.853v-2.854Zm0-4.147h-2.853v2.876h2.853V87.48Zm0-4.146h-2.853v2.853h2.853v-2.853Z"
      clipRule="evenodd"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M212.588 73.947v4.17a.942.942 0 0 1-.937.935.946.946 0 0 1-.958-.936v-4.169c0-.535.423-.958.958-.958.246 0 .491.111.669.29a.962.962 0 0 1 .268.668ZM205.164 73.947v4.17a.946.946 0 0 1-.958.935.942.942 0 0 1-.936-.936v-4.169c0-.535.423-.958.936-.958a.93.93 0 0 1 .669.29.89.89 0 0 1 .289.668ZM197.718 73.947v4.17a.942.942 0 0 1-.936.935.947.947 0 0 1-.959-.936v-4.169c0-.535.424-.958.959-.958.245 0 .49.111.669.29a.961.961 0 0 1 .267.668ZM190.294 73.947v4.17a.946.946 0 0 1-.958.935.942.942 0 0 1-.937-.936v-4.169c0-.535.424-.958.937-.958.267 0 .512.111.669.29a.89.89 0 0 1 .289.668ZM182.849 73.947v4.17c0 .244-.112.49-.268.668a.944.944 0 0 1-.669.267.946.946 0 0 1-.958-.936v-4.169a.89.89 0 0 1 .289-.669.891.891 0 0 1 .669-.29c.513 0 .937.424.937.96ZM47.862 89.441c0-8.338-6.755-15.092-15.093-15.092-8.316 0-15.093 6.754-15.093 15.092 0 8.338 6.777 15.093 15.093 15.093 8.338 0 15.093-6.755 15.093-15.093Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M46.123 89.441c0-7.379-5.975-13.353-13.354-13.353-7.357 0-13.331 5.974-13.331 13.353 0 7.38 5.974 13.354 13.331 13.354 7.38 0 13.354-5.975 13.354-13.354Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M34.062 89.441c0-.713-.58-1.27-1.293-1.27a1.27 1.27 0 0 0-1.271 1.27c0 .691.58 1.271 1.27 1.271.714 0 1.294-.58 1.294-1.27Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m37.428 91.715-4.659-2.274-7.736 8.472"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M168.559 199.905H60.926a2.716 2.716 0 0 1-2.72-2.72V35.201a2.702 2.702 0 0 1 2.72-2.72h107.633a2.716 2.716 0 0 1 2.719 2.72v161.984a2.73 2.73 0 0 1-2.719 2.72Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M165.526 193.462H63.957V36.249h101.569v157.213Z"
    />
    <path
      stroke="#263238"
      strokeMiterlimit={10}
      strokeWidth={0.464}
      d="M128.921 77.046h7.892M74.212 77.046h48.6M117.216 83.154h19.596M87.188 83.154h24.701M74.212 83.154h8.405M98.646 89.24h38.166M74.212 89.24h16.03M159.262 82.642a6.622 6.622 0 0 0-6.621-6.621c-3.656 0-6.599 2.965-6.599 6.62a6.584 6.584 0 0 0 6.599 6.6c3.656 0 6.621-2.943 6.621-6.6ZM82.104 104.266h-7.892M136.813 104.266h-48.6M93.808 110.375H74.212M123.838 110.375h-24.68M136.812 110.375h-8.404M112.379 116.483H74.212M136.813 116.483h-16.029M159.262 109.862a6.622 6.622 0 0 0-6.621-6.621c-3.656 0-6.599 2.965-6.599 6.621 0 3.656 2.943 6.621 6.599 6.621a6.622 6.622 0 0 0 6.621-6.621ZM128.921 131.487h7.892M74.212 131.487h48.6M117.216 137.595h19.596M87.188 137.595h24.701M74.212 137.595h8.405M98.646 143.704h38.166M74.212 143.704h16.03M159.262 137.082a6.622 6.622 0 0 0-6.621-6.621c-3.656 0-6.599 2.965-6.599 6.621 0 3.657 2.943 6.622 6.599 6.622a6.622 6.622 0 0 0 6.621-6.622Z"
    />
    <path
      fill="#263238"
      fillRule="evenodd"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M124.15 20.153V33.33h-14.959V20.153c0-.468.379-.847.869-.847.469 0 .848-.401.848-.87v-4.86c0-1.025.824-1.85 1.85-1.85h7.825c1.025 0 1.85.825 1.85 1.85v4.86c0 .469.379.87.87.87.468 0 .847.38.847.847Zm-5.061-3.723a2.411 2.411 0 0 0-2.407-2.407 2.416 2.416 0 0 0-2.43 2.407 2.416 2.416 0 0 0 2.43 2.408 2.411 2.411 0 0 0 2.407-2.408Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M140.045 37.43H93.318v-4.436a3.858 3.858 0 0 1 3.857-3.857h39.014a3.872 3.872 0 0 1 3.856 3.857v4.437Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M94.478 30.564h44.408a4.424 4.424 0 0 0-3.255-1.427h-37.92c-1.294 0-2.43.558-3.233 1.427Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M140.045 40.106H93.318v-2.72h46.727v2.72Z"
    />
    <path fill="#fff" d="m150.122 108.77 1.805 3.188 6.8-6.599" />
    <path
      stroke="#0038FF"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2.322}
      d="m150.122 108.77 1.805 3.188 6.8-6.599M150.122 81.26l1.805 3.188 6.8-6.6"
    />
    <path
      stroke="#263238"
      strokeMiterlimit={10}
      strokeWidth={0.464}
      d="M128.921 50.116h7.892M74.212 50.116h48.6M117.216 56.224h19.596M87.188 56.224h24.701M74.212 56.224h8.405M98.646 62.333h38.166M74.212 62.333h16.03M159.262 55.711c0-3.633-2.965-6.599-6.621-6.599a6.598 6.598 0 0 0-6.599 6.6c0 3.655 2.943 6.62 6.599 6.62a6.622 6.622 0 0 0 6.621-6.62Z"
    />
    <path
      stroke="#0038FF"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2.322}
      d="m150.122 54.33 1.805 3.21 6.8-6.6M149.186 134.719l1.783 3.211 6.8-6.599"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M185.524 92.585s2.407 2.05 2.229 3.834c-.178 1.806-2.586 6.198-3.143 7.491-.558 1.293.735 4.392.735 4.392l-8.025 2.697s.178-.981 0-1.404c-.201-.446-.513-1.606-.513-1.606s-1.226.424-1.605.558c-.357.111-1.65-.513-1.717-1.048-.067-.557-.067-.936-.134-1.739-.067-.802-.178-2.229-.312-2.475-.111-.245-1.36-1.047-1.293-1.493.067-.424 1.494-2.096 1.605-2.653.134-.557-.178-1.784-.067-2.475.134-.668 1.316-3.01 1.316-3.01s-.758-.623 1.293-2.295c2.029-1.672 7.156-2.163 9.631 1.226Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M185.524 92.585c-2.475-3.389-7.602-2.898-9.631-1.226-2.051 1.672-1.293 2.296-1.293 2.296l1.85 1.404s-1.739 1.984-1.493 2.23c.245.245 1.605 1.984 1.605 1.984l-.112.58-.245-.937s-.758 3.076-.914 3.834c-.134.781-.134 1.048-.468 1.16-.334.089-1.784-.625-1.784-.625s0 1.829-.044 2.587c-.045.78-.112 1.404-.156 2.073-.045.669.958 1.761 2.162 1.538 1.204-.245 1.851-.869 1.806-1.494-.022-.624.401-2.786.223-3.21-.201-.446-.557-2.586-.223-3.522 0 0 .803-1.74 1.672-1.74.87 0 1.003 2.342.758 2.899-.267.557-.379.869-.379.869s0 .379 2.408 1.182c1.806.602 2.809.268 3.21.045.022-.223.045-.424.134-.602.557-1.293 2.965-5.685 3.143-7.49.178-1.784-2.229-3.835-2.229-3.835Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M178.858 103.285s-.557.87-1.048 1.048c-.49.179-.802-.49-.802-.49"
    />
    <path
      fill="#263238"
      d="M173.552 99.34c0 .445.112.802.245.802.134 0 .246-.357.246-.802 0-.446-.112-.803-.246-.803-.133 0-.245.357-.245.803Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M174.288 98.336s.111-.802-.87-.423"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M173.686 105.069s.691-.178.936-.49"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M151.058 120.875h14l3.233 10.968h-13.978l-3.255-10.968Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M152.062 121.499h12.372l2.876 9.698h-12.373l-2.875-9.698ZM171.479 132.691h-17.055v-.736h17.055v.736ZM176.874 202.826s-1.494 2.118-2.519 2.675c-1.004.535-3.501 1.181-3.501 1.828 0 .646.179.758 1.294 1.115 1.092.379 3.143.379 4.235.379 1.115 0 2.319 0 2.698.089.356.089 2.385.267 3.321.267.915 0 .87-2.452.87-2.452l-6.398-3.901Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M191.744 150.458s-2.185 17.256-4.236 22.985c-2.051 5.752-1.204 7.491-2.608 13.331-1.405 5.864-1.628 19.641-1.628 19.953 0 .334-.646 0-2.92-1.182-2.274-1.203-3.478-2.719-3.478-2.719s.111-1.182.334-2.051c.223-.87.647-3.144.647-3.144s-.87-7.379.111-19.194c.981-11.816 1.405-25.816 1.405-25.816s7.936-1.07 12.373-2.163Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M180.842 206.571s-1.56 1.627-2.541 2.14c-.981.513-4.013 1.628-4.08 2.073-.067.469.245 1.36.446 1.427.201.067 2.787.535 5.261.58 2.475.067 5.328-.245 6.042-.245.713 0 2.407.646 2.474-1.293.045-1.962-.981-4.749-.981-4.749s-3.455 1.048-6.621.067Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M185.903 156.924s-.781 11.146-1.182 14.513c-.401 3.344.401 10.455 1.271 15.382.892 4.949 1.204 15.115 1.204 15.115s.579.379.289.981c-.289.58-.601 1.471-.601 1.471s1.092.402 1.003 1.093c-.112.691-.402 1.984-.402 1.984s-.601.089-2.675.089c-2.073 0-3.745-.401-3.745-.401l-.78-.379s-.201-1.583-.201-2.475c0-.892.981-1.783.892-2.274-.112-.49-.602-3.255-1.003-5.529-.379-2.274-.09-3.656-.781-6.019-.691-2.363-4.548-16.475-4.548-16.475s-1.761-16.385-1.872-18.659c-.089-2.274-.089-3.255-.089-3.255s3.054-2.475 3.745-2.475c.691 0 9.475 7.313 9.475 7.313Z"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M172.393 150.392s-.335 2.496 0 2.987c.334.513 3.277 1.315 6.933 1.694 3.656.401 8.36 0 9.921-.557 1.582-.558 2.608-1.07 2.831-1.472.223-.379.044-2.474.044-2.474s-14.602.847-19.729-.178Z"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M186.638 109.773s5.195 3.478 6.153 8.984c.87 4.905-.535 22.227-.535 23.141 0 .936.714 8.449.714 8.449.735 1.583-5.262 3.01-8.561 3.322-2.92.267-9.363-.379-11.214-1.293-.579-.29-1.137-.602-1.159-1.249-.067-3.032-.223-11.102-.022-12.306.245-1.493-.022-10.143-.022-13.108s-1.115-7.469-.112-9.386c.981-1.917 3.522-3.21 3.522-3.21s4.638-3.835 11.236-3.344Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M186.683 127.296c-.513.98-.981 1.761-1.338 2.162M190.228 119.916s-1.204 2.698-2.453 5.284M187.798 128.477l-2.631 3.5"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m186.705 107.231 1.182 2.965s-2.475.134-4.771.446c-2.274.312-7.714 2.475-7.714 2.475s.558-2.229.981-2.653c.424-.446 2.051-2.051 5.128-2.72 3.099-.691 5.194-.513 5.194-.513Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M177.765 135.388s-.401 4.659-.914 4.882c-.512.223-13.242-4.213-14.156-4.659-.914-.468-1.427-.401-1.605-.468-.178-.045-1.717-.045-2.274-.335-.58-.289-1.159-1.025-1.315-1.137-.179-.111-1.539-.178-1.94-.468-.401-.29-.914-.512-.579-.691.334-.156 2.051-.513 2.051-.513s.066-.78.757-.914c.669-.111.446.179 2.096-.78 1.672-.981 1.494-.178 2.921.847 1.426 1.026 2.117 2.163 2.273 2.23.179.044 5.373 2.006 5.373 2.006h7.312Z"
    />
    <path fill="#fff" d="m157.033 131.999 2.809-.334-2.809.334Z" />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m157.033 131.999 2.809-.334"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M166.396 133.828s-.78-.669-1.315-.446c-.513.223-1.293 1.226-1.36 2.452-.09 1.226 1.917 1.382 1.917 1.382l.758-3.388Z"
    />
    <path
      fill="#0038FF"
      d="M176.918 113.674c-1.025 0-3.745.736-4.57 1.672-.847.937-.936 3.656-.669 7.312.29 3.634 1.717 10.478 1.717 10.501 0-.067-.178.356-.223.446-.178.334.29.379-.156.468-.156.022-1.003.111-1.159.089a89.291 89.291 0 0 0-1.962-.334c-1.07-.179-2.898-.424-3.968-.424-.424 0-1.516 3.344-.892 4.08.624.735 13.019 5.551 13.866 5.328.825-.201 2.408-11.147 2.386-11.214.245-2.987.535-6.51.602-6.889"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M176.918 113.674c-1.025 0-3.745.736-4.57 1.672-.847.937-.936 3.656-.669 7.312.29 3.634 1.717 10.478 1.717 10.501 0-.067-.178.356-.223.446-.178.334.29.379-.156.468-.156.022-1.003.111-1.159.089a89.291 89.291 0 0 0-1.962-.334c-1.07-.179-2.898-.424-3.968-.424-.424 0-1.516 3.344-.892 4.08.624.735 13.019 5.551 13.866 5.328.825-.201 2.408-11.147 2.386-11.214.245-2.987.535-6.51.602-6.889"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M173.017 134.073s1.405 1.449 2.631 2.385M174.176 136.213s1.093 1.003 1.851 1.315"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M127.94 105.938c-.246-1.538-1.271-2.563-1.539-3.5-.245-.936-.847-2.028-.847-2.028s-1.493 3.032-1.984 5.573l-.223-.535-4.236 3.322-.245 7.379 6.867.312s-.29-1.226-.379-2.118c-.112-.914.022-2.341.156-2.675 0 0 1.939.044 2.095-.647.179-.691.602-3.544.335-5.083Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M126.848 103.219s.535.2.802.2c.245 0 .691.045.535.647-.156.602-.49.802-.49.802l-.847-1.649ZM124.796 188.469s-.936 15.94-.936 16.207c0 .245-1.182 4.191-1.003 4.793.178.58 1.516.758 2.452.847.914.067 2.854.335 3.612.335s3.455-.179 3.945-.335c.513-.178 1.182-.691.602-1.114-.602-.402-2.028-.58-3.7-2.52-1.695-1.939-2.118-2.764-2.118-2.764l3.544-15.271-6.398-.178ZM101.143 185.526s-6.554 16.319-7.044 16.988c-.513.691-3.924 4.993-4.013 5.818-.067.847 4.28.936 5.038.424.758-.513 1.65-4.883 2.163-5.819.512-.914 11.681-16.229 11.681-16.229l-7.825-1.182Z"
    />
    <path
      fill="#8F8F8F"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m112.2 138.086-.134 2.742s-3.41 7.379-6.732 16.519c-3.612 9.965-8.338 27.176-8.338 27.176s3.121 2.876 11.593 4.236c8.449 1.359 13.732 1.939 18.325 1.805 5.573-.156 12.663-1.672 12.663-1.672s-3.969-24.411-7.224-35.491c-3.232-11.08-3.99-12.172-3.99-12.172l-1.115-6.175-15.048 3.032Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m117.484 156.946-.936 32.682M117.551 154.516l-.045 1.293M124.618 141.474c.52-.104 1.026-.238 1.516-.401M113.561 141.697s4.637.624 9.14.089"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M143.211 105.894s-.357-1.65-.424-2.742c-.067-1.093-1.092-2.564-.981-3.166.134-.624.736-.557 1.048-.379.29.2.669.803.669.803s.847-2.631.847-3.79c0-1.16.736-1.026 1.048-.246.29.803-.134 3.857-.134 3.857s1.159.29 1.717.535c.535.246 1.583.736 1.404 2.274-.2 1.516-.379 2.363-.736 2.363-.379 0-.668-.49-.668-.49s0 1.65-.558 2.14c-.557.491-1.649.557-1.649.557s.133-1.226-1.583-1.716Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M147 104.913s.357-1.405.357-1.583M143.523 100.41l-.379 1.716"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m141.695 107.61 1.159-1.961s.424-.602 1.494-.246h.022a1.932 1.932 0 0 1 1.248 2.341l-.289 1.093s-2.297-1.316-3.634-1.227Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M93.764 146.557s.29 1.471.423 2.497c.134 1.048.825 3.121 1.316 3.411.49.267 1.114.624.423.825-.713.223-1.114.289-1.739-.201-.624-.49-1.047-1.048-1.047-1.048s-.49 2.163-.825 3.188c-.357 1.048-1.382 2.72-1.382 2.72s-.045.557-.469.758c-.4.201-.713-.624-.713-.624s-.557 1.293-.914-.067c-.134-.557-.624-4.169-.557-4.86.067-.691 2.876-7.112 2.876-7.112l2.608.513Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M89.818 154.204c-.223.401-.424.914-.424 1.092 0 .29.357 2.787.357 2.787M90.933 157.949l-.357-2.43.624-1.605M91.4 157.102s.045-1.293.135-1.895c.089-.602.223-.491.423-1.226M92.092 150.726s-.067.624-.535 1.115c-.49.49-1.472 1.181-1.472 1.181"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M110.685 117.063s-5.663 2.742-5.997 3.433c-.357.713-7.424 13.354-8.405 14.58-.958 1.248-3.968 2.831-4.325 4.057-.356 1.249-.089 4.615-.089 4.615l-.713 2.296s.089.781 1.337 1.048l1.227.268 2.117-2.029s4.593-1.159 6.465-3.366c1.851-2.207 6.354-12.552 6.354-12.552l-.713 7.001s4.592.691 10.076.245c5.485-.424 11.481-1.316 11.481-1.316l-.78-8.137s13.064-2.118 13.778-2.719c.713-.625 1.315-2.297 1.404-2.921.089-.624 2.296-12.462 2.296-12.462s-.78-1.315-2.653-1.672c-1.85-.357-3.7.602-3.79 1.137-.089.535-3.879 8.226-3.879 8.226s-.267-.178-1.248.268c-.959.423-2.675-.268-2.675-.268s-3.411-.981-5.373-.802c-1.939.178-3.79.446-3.79.446s-3.455-1.583-5.997-.892c-2.564.713-6.108 1.516-6.108 1.516Z"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m122.879 128.009 5.841-.803-3.902 2.051M108.745 125.445l-.089 3.968-1.316-1.672M92.671 144.082s.268.892 2.386.892"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M115.478 109.951c2.898 2.252 5.35.892 6.398-.156 1.271-1.271 1.248-2.943 2.073-4.525.112-.58 2.029-2.609 2.185-3.099.334-1.115-.312-3.054-.312-3.054s1.873.267 1.025-1.606c-.869-1.872-1.627-2.563-3.41-2.72-1.784-.178-2.809 1.271-2.809 1.271s-2.118-1.025-3.567-.245c-1.449.758-3.545 0-5.262 5.172-.156.468-.49 1.271-.512 1.828-.09 1.516.78 2.586 1.627 3.812 1.315 1.918.736 1.918 2.564 3.322Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M118.955 107.521a2.18 2.18 0 0 1-2.162 2.163 2.18 2.18 0 0 1-2.163-2.163 2.18 2.18 0 0 1 2.163-2.162c1.181 0 2.162.981 2.162 2.162Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M112.869 111.489c0 1.36 0 2.653-1.204 3.567-1.315 1.004-6.465 4.816-3.656 8.717 2.832 3.902 3.233 2.809 2.988 4.147-.246 1.315-5.73 4.971-4.727 8.204.981 3.232 5.061 5.06 4.481 6.286-.579 1.249 1.227 7.38 8.271 4.147 7.045-3.232 6.577-8.784 3.746-15.07-.669-1.472-.357-3.322 2.296-6.309 2.653-2.988.669-8.717-2.14-11.615-1.65-1.695-2.319-3.054-2.23-3.389.067-.334-2.563-4.236-4.815-3.076-1.382.735-2.698 2.118-2.965 3.723-.045.223-.06.446-.045.668Z"
    />
    <path
      fill="#fff"
      d="M123.949 105.27s-.869-1.227-1.471.089c-.602 1.293.134 2.608.736 3.099.602.468 1.048-1.271 1.048-1.271"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M123.949 105.27s-.869-1.227-1.471.089c-.602 1.293.134 2.608.736 3.099.602.468 1.048-1.271 1.048-1.271"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M132.866 210.316c.513-.178 1.182-.691.602-1.114-.602-.402-2.029-.58-3.701-2.52l-.089 1.516s-3.79-.156-6.487-.78c-.223.914-.401 1.784-.334 2.051.178.58 1.515.758 2.452.847.914.067 2.853.335 3.611.335s3.456-.179 3.946-.335ZM95.124 208.756c.312-.201.647-1.093.981-2.096-1.85.112-3.678-.29-4.682-.579-.713 1.003-1.293 1.917-1.337 2.251-.067.847 4.28.936 5.038.424Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M36.626 174.201h-3.723v-6.644h3.723v6.644Z"
    />
    <path
      fill="#949494"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M36.827 169.564h-4.704c-3.835 0-6.956-3.121-6.956-6.956v-14.58c0-3.834 3.121-6.955 6.956-6.955h4.704c3.856 0 6.977 3.121 6.977 6.955v14.58c0 3.835-3.12 6.956-6.977 6.956Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M28.89 208.979a1.57 1.57 0 0 0-1.583-1.561 1.57 1.57 0 0 0-1.582 1.561c0 .891.713 1.583 1.582 1.583.87 0 1.583-.692 1.583-1.583ZM59.811 208.979a1.57 1.57 0 0 0-1.583-1.561 1.57 1.57 0 0 0-1.583 1.561c0 .891.714 1.583 1.583 1.583.87 0 1.583-.692 1.583-1.583ZM43.537 208.979c0-.87-.335-1.561-.736-1.561-.401 0-.736.691-.736 1.561 0 .891.335 1.583.736 1.583.401 0 .736-.692.736-1.583Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M44.25 200.396v-22.673h-3.12v22.762l-15.317 6.064v1.538h2.23v-1.293L42.8 203.74l14.78 3.054v1.293h2.23v-1.538l-15.56-6.153Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M42.02 208.087h1.561l.335-7.379h-2.23l.335 7.379ZM46.636 181.535h-7.892v-4.681h7.892v4.681Z"
    />
    <path
      fill="#949494"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M53.858 178.57H30.764a2.621 2.621 0 0 1-2.631-2.63v-.758a2.64 2.64 0 0 1 2.63-2.653h23.096a2.645 2.645 0 0 1 2.653 2.653v.758c0 1.471-1.181 2.63-2.653 2.63Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m76.263 186.551 2.364 3.501 2.786-.179s4.102.045 4.793-.134c.714-.156.959.446.625 1.137-.357.714-3.389 2.876-4.972 3.857-1.56.959-4.971 2.475-5.417 2.564-.424.089-.959-.78-1.917-3.5-.959-2.698-2.698-5.417-2.698-5.417l4.436-1.829Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M86.83 190.876c.335-.691.09-1.293-.623-1.137-.691.179-4.793.134-4.793.134l-2.787.179c.09 1.56.446 2.363.446 2.363s-3.946.958-4.548 1.382c.959 2.72 1.494 3.589 1.917 3.5.446-.089 3.857-1.605 5.417-2.564 1.583-.981 4.615-3.143 4.972-3.857Z"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M86.697 189.784c-.557.602-1.538 1.471-3.166 2.541-2.675 1.762-6.376 3.367-7.98 4.013.378.736.646 1.004.891.959.446-.089 3.857-1.605 5.417-2.564 1.583-.981 4.615-3.143 4.972-3.857.245-.49.178-.936-.134-1.092ZM70.155 158.841c.335-.714 2.943 8.828 5.039 17.924 1.404 6.153 2.63 9.831 2.63 9.831s-1.984 1.717-3.21 2.319c-1.226.602-3.322 1.404-3.322 1.404s-3.12-6.799-4.86-10.21c-1.739-3.389-2.23-5.663-3.634-8.204-1.404-2.542-1.76-7.09-1.76-7.09s-.87-4.369 2.452-5.506c3.321-1.137 5.707-1.672 6.665-.468Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M60.926 195.58s-.602 3.746-1.003 5.106c-.402 1.359-1.538 3.834-1.182 4.458.357.624 2.207 1.249 3.166 1.338.958.067 2.162 1.627 3.946 2.274 1.76.646 4.102.468 4.035 0-.045-.468-5.24-6.176-5.484-7.558-.245-1.382.646-5.729.646-5.729l-4.124.111Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m63.757 202.112-.134.402s-2.407-.268-4.057-.803c-.468 1.338-1.093 2.943-.825 3.433.357.624 2.207 1.249 3.166 1.338.958.067 2.162 1.627 3.946 2.274 1.76.646 4.102.468 4.035 0-.045-.468-5.24-6.176-5.484-7.558 0 0-.513.535-.647.914Z"
    />
    <path
      fill="#0038FF"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M65.741 207.819c-1.404-.691-2.675-1.85-4.526-2.474-1.226-.424-2.05-.758-2.496-.936-.067.334-.067.579.022.735.357.624 2.207 1.249 3.166 1.338.958.067 2.162 1.627 3.946 2.274 1.672.602 3.879.468 4.035.067-1.182-.179-3.188-.535-4.147-1.004ZM60.012 167.446s6.888.803 7.401 4.28c.535 3.5-.69 25.237-.69 25.237s-1.65.089-3.055-.179c-1.404-.267-3.745-.78-3.745-.78s-.357-7.424-.803-10.389c-.423-2.965-.78-11.615-.78-11.615s-11.526-.958-12.574-1.649c-1.047-.714 14.246-4.905 14.246-4.905Z"
    />
    <path
      fill="#0038FF"
      d="M69.085 164.994s-17.032 6.732-20.956 8.048c-3.923 1.315-8.204.958-10.901.089-2.72-.87-4.035-4.347-4.035-4.347s-.692-.803-.335-1.583c.335-.803 5.93-5.774 9.341-6.644 3.411-.869 9.564-.49 9.564-.49s14.87-3.812 16.698-3.545c1.828.268 3.3 6.777 3.567 7.669"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M69.085 164.994s-17.032 6.732-20.956 8.048c-3.923 1.315-8.204.958-10.901.089-2.72-.87-4.035-4.347-4.035-4.347s-.692-.803-.335-1.583c.335-.803 5.93-5.774 9.341-6.644 3.411-.869 9.564-.49 9.564-.49s14.87-3.812 16.698-3.545c1.828.268 3.3 6.777 3.567 7.669"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M37.139 169.452s1.226-4.793 4.436-6.799M36.425 166.242s1.316-2.029 3.055-2.452"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M50.069 134.006s1.204 1.315 2.608 4.726c1.405 3.433 3.7 13.777 3.7 13.777s-1.158.469-2.072.469c-.892 0-2.096.133-2.609-.469-.49-.602-1.94-5.328-1.94-5.328s-.69-5.729-.891-8.65c-.2-2.92-1.115-3.522-.2-4.414.891-.914 1.404-.111 1.404-.111Z"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M46.613 131.955s2.586.624 3.456 2.051c.847 1.427.468 4.704.468 4.704s2.296 6.643 1.873 8.204c-.446 1.583-2.163 3.857-2.163 3.857s.156 5.149.58 6.153c.423 1.003.936 3.143.936 3.143s-1.226.847-5.217 1.427c-4.012.579-7.29.847-8.65 1.939-1.36 1.07-4.347 5.128-4.703 5.351-.357.2-.647-.58-.937-1.16-.29-.579-.223-2.296.424-4.86.646-2.586.98-10.032.089-14.758-.98-5.127-1.516-5.863-.936-9.229.557-3.344 8.494-8.472 9.63-8.672 1.16-.223 5.15 1.85 5.15 1.85Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M33.995 164.481s2.185-2.519 3.233-2.965c1.047-.446 8.382-.446 8.382-.446M35.556 161.248s1.226-.691 2.184-.869c.959-.178 3.5 0 3.5 0"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M39.39 152.532s3.322-1.137 6.376-4.102"
    />
    <path
      fill="#fff"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M46.725 114.031s.98 2.073 1.293 2.697c.312.647.2 1.739.446 2.653.267.892 1.739 1.472 1.739 1.984 0 .513-.58 1.539-.58 1.539s-.312 3.99-.825 4.436c-.513.446-2.653.58-2.653.58l-.178 3.812 1.226.713s.2 4.214 0 5.73c-.223 1.493-.892 1.806-2.787.669-2.118-1.249-4.86-4.615-5.15-5.329-.29-.713.602-3.21-.69-7.334-1.294-4.102 1.538-7.825 3.41-9.564 1.873-1.739 2.765-2.898 4.749-2.586Z"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M46.725 114.031c-.067-1.159-.179-1.605-2.564-1.85-2.385-.268-7.468-.469-9.452 3.076-1.985 3.545-1.985 11.258-1.985 11.258s-5.172 3.233-5.528 5.797c-.357 2.563 1.36 4.993 4.057 5.863.06.015.111.029.156.044.245-1.025.691-2.34 1.494-3.299 1.538-1.85 2.876-1.65 4.837-2.163 1.985-.535 3.21-.646 3.5-2.875.29-2.252.201-3.634.023-5.685-.067-.781.78-1.94.78-1.94s1.984.513 3.277-2.943c1.293-3.477 1.472-4.124 1.405-5.283Z"
    />
    <path
      fill="#fff"
      d="M42.868 123.238s-.646-2.965-2.318-1.806c-1.65 1.16.847 4.437 1.226 4.504.401.067 1.025-.335 1.025-.335"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M42.868 123.238s-.646-2.965-2.318-1.806c-1.65 1.16.847 4.437 1.226 4.504.401.067 1.025-.335 1.025-.335"
    />
    <path
      fill="#263238"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m46.145 127.92-1.984-.245 1.873.312.111-.067Z"
    />
    <path
      fill="#263238"
      d="M48.263 120.117c.09.424 0 .803-.2.847-.179.045-.402-.29-.49-.713-.09-.446 0-.825.2-.87.178-.022.401.29.49.736Z"
    />
    <path fill="#fff" d="m38.03 140.582-.668-.847.669.847Z" />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="m38.03 140.582-.668-.847"
    />
    <path
      fill="#fff"
      d="M35.645 132.668s-2.497-.089-4.392 2.564c-1.895 2.675-1.204 6.019-.69 7.401.534 1.36 4.659 9.453 5.26 10.478.602 1.026 2.743 2.497 3.255 2.676.513.156 2.23-9.297 2.074-10.144-.179-.869-4.147-6.889-4.147-6.889"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M35.645 132.668s-2.497-.089-4.392 2.564c-1.895 2.675-1.204 6.019-.69 7.401.534 1.36 4.659 9.453 5.26 10.478.602 1.026 2.743 2.497 3.255 2.676.513.156 2.23-9.297 2.074-10.144-.179-.869-4.147-6.889-4.147-6.889M37.362 155.318s-1.628-.178-2.252-.089c-.624.089-.49.201-.156.535.357.357 1.092.201 1.092.201l1.316-.647Z"
    />
    <path
      fill="#fff"
      d="M55.464 150.28c.669.647 2.185 4.749-.736 5.328-2.898.602-10.544-.178-10.857.112-.29.289-2.697 2.184-3.232 2.563-.535.379-1.739.825-1.739.825s-1.115.87-1.404.669c-.29-.178.29-.669.29-.669s-1.182.669-1.561.736c-.38.045-.335-.535-.335-.535-.2.134-.58.089-.58.089s-.155-.446.18-.825c.356-.379 2.005-1.984 2.005-1.984s-1.025.335-1.114.491c-.112.133-.691.535-1.026.824-.334.29-.624.223-.735 0-.09-.245.446-1.07 1.003-1.627.557-.557 3.433-1.672 3.99-1.672.58 0 5.328-1.494 5.328-1.494s8.74-3.009 8.962-3.121"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M55.464 150.28c.669.647 2.185 4.749-.736 5.328-2.898.602-10.544-.178-10.857.112-.29.289-2.697 2.184-3.232 2.563-.535.379-1.739.825-1.739.825s-1.115.87-1.404.669c-.29-.178.29-.669.29-.669s-1.182.669-1.561.736c-.38.045-.335-.535-.335-.535-.2.134-.58.089-.58.089s-.155-.446.18-.825c.356-.379 2.005-1.984 2.005-1.984s-1.025.335-1.114.491c-.112.133-.691.535-1.026.824-.334.29-.624.223-.735 0-.09-.245.446-1.07 1.003-1.627.557-.557 3.433-1.672 3.99-1.672.58 0 5.328-1.494 5.328-1.494s8.74-3.009 8.962-3.121"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M47.928 152.086s1.026 1.516-.29 3.522M35.89 159.309l1.806-1.538.98-.781M37.785 159.108s1.45-1.181 1.583-1.226"
    />
    <path
      fill="#fff"
      d="M35.823 149.255c.067 1.761-.468 4.302 2.118 5.93 1.249.78 3.099 1.516 4.035-.535.959-2.029 1.605-20.332 1.605-20.332l1.093-.29c1.07-.312 1.672-2.095 1.672-2.095s-.49.602 0 1.092c.49.513 2.475-1.561 2.564-2.163.089-.579-1.293-2.474-1.293-2.474s.602-.29.512-1.07c-.111-.803-2.83-.022-2.83-.022l-1.628 2.095s-2.363 3.054-2.564 3.835c-.156.668-2.408 7.78-3.7 10.923"
    />
    <path
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.464}
      d="M35.823 149.255c.067 1.761-.468 4.302 2.118 5.93 1.249.78 3.099 1.516 4.035-.535.959-2.029 1.605-20.332 1.605-20.332l1.093-.29c1.07-.312 1.672-2.095 1.672-2.095s-.49.601 0 1.092c.49.513 2.475-1.561 2.564-2.163.089-.579-1.293-2.474-1.293-2.474s.602-.29.512-1.07c-.111-.803-2.83-.022-2.83-.022l-1.628 2.095s-2.363 3.054-2.564 3.835c-.156.668-2.408 7.78-3.7 10.923M39.457 138.554l3.59 1.382"
    />
  </svg>
)
export default CompleteProfileSvg
